import ReducerRegistry from '../base/redux/ReducerRegistry';
import { set } from '../base/redux/functions';
import { CAPTURE_PAY_EVENTS, PAY_ACTIVE, SET_CONTROLLED_PAY_PARTICIPANT, SET_PAY_CONTROLLER, SET_RECEIVER_PAY_ENABLED, SET_RECEIVER_PAY_TRANSPORT, SET_REQUESTED_PAY_PARTICIPANT } from './actionTypes';
/**
 * The default state.
 */
const DEFAULT_STATE = {
    active: false,
    controller: {
        isCapturingEvents: false
    },
    receiver: {
        enabled: false
    }
};
/**
 * Listen for actions that mutate the pay state.
 */
ReducerRegistry.register('features/pay-service-charge', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CAPTURE_PAY_EVENTS:
            return {
                ...state,
                controller: set(state.controller, 'isCapturingEvents', action.isCapturingEvents)
            };
        case PAY_ACTIVE:
            return set(state, 'active', action.active);
        case SET_RECEIVER_PAY_TRANSPORT:
            return {
                ...state,
                receiver: set(state.receiver, 'transport', action.transport)
            };
        case SET_RECEIVER_PAY_ENABLED:
            return {
                ...state,
                receiver: set(state.receiver, 'enabled', action.enabled)
            };
        case SET_REQUESTED_PAY_PARTICIPANT:
            return {
                ...state,
                controller: set(state.controller, 'requestedParticipant', action.requestedParticipant)
            };
        case SET_CONTROLLED_PAY_PARTICIPANT:
            return {
                ...state,
                controller: set(state.controller, 'controlled', action.controlled)
            };
        case SET_PAY_CONTROLLER:
            return {
                ...state,
                receiver: set(state.receiver, 'controller', action.controller)
            };
    }
    return state;
});
